import React, { useEffect } from 'react';
import { setVideoPlayerPlaying } from '../actions'
import { useDispatch, useSelector } from 'react-redux'

export default function EmbeddedPlayer({ streamSource, ...props }) {
  
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)
  const dispatch = useDispatch()

  useEffect(() => {
    if(!videoPlayerPlaying){
      dispatch(setVideoPlayerPlaying(true))
    }
    
    return () => {
      if(videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(false))
      }
      
    }
  }, []);

  return (
    <>
      <div className="flave-video-container" dangerouslySetInnerHTML={{ __html: streamSource}}/>  
    </>
  )
}

